import React from "react";
import { FileText, MessageSquareText } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SectionPanel } from "@/views/gooseberry/shared";

const copy = {
  nl: {
    title: "Outputmodus",
    description: "Kies hoe de AI moet reageren: een gestructureerd rapport of een dialoog tussen synthetische gebruikers.",
    feedback: "Feedback",
    dialogue: "Dialoog",
    feedbackHint: "Een gestructureerd rapport met secties.",
    dialogueHint: "Een gesprek tussen 2-4 synthetische gebruikers.",
  },
  en: {
    title: "Output mode",
    description: "Choose how the AI should respond: a structured report or a dialogue between synthetic users.",
    feedback: "Feedback",
    dialogue: "Dialogue",
    feedbackHint: "A structured report with sections.",
    dialogueHint: "A conversation between 2-4 synthetic users.",
  },
};

export function ModePanel({ mode, setMode, language = "en" }) {
  const t = copy[language] || copy.en;

  return (
    <SectionPanel
      number="7"
      title={t.title}
      required
      description={t.description}
      testid="synberry-mode-card"
    >
      <Tabs value={mode} onValueChange={setMode} data-testid="synberry-mode-toggle">
        <TabsList className="bg-white border border-black/15 rounded-xl p-1">
          <TabsTrigger value="feedback" className="rounded-lg data-[state=active]:bg-[#61CBA3] data-[state=active]:text-white" data-testid="synberry-mode-feedback">
            <FileText className="h-3.5 w-3.5 mr-1.5" /> {t.feedback}
          </TabsTrigger>
          <TabsTrigger value="dialogue" className="rounded-lg data-[state=active]:bg-[#61CBA3] data-[state=active]:text-white" data-testid="synberry-mode-dialogue">
            <MessageSquareText className="h-3.5 w-3.5 mr-1.5" /> {t.dialogue}
          </TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="mt-1 text-[11px] text-black/55">
        {mode === "feedback" ? t.feedbackHint : t.dialogueHint}
      </div>
    </SectionPanel>
  );
}
